import { render, staticRenderFns } from "./AdminViewTicket.vue?vue&type=template&id=1a5e429a&scoped=true&"
import script from "./AdminViewTicket.vue?vue&type=script&lang=js&"
export * from "./AdminViewTicket.vue?vue&type=script&lang=js&"
import style0 from "./AdminViewTicket.vue?vue&type=style&index=0&id=1a5e429a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5e429a",
  null
  
)

export default component.exports